import { useEffect } from "react";
import { Input } from "../input";
import { MAX_LENGTH } from "./constants";
import { OTPInputProps } from "./types";

export const OTPInput = ({
  code,
  setCode,
  errorMessage,
  length = MAX_LENGTH,
}: OTPInputProps) => {
  useEffect(() => {
    const inputElement = document.querySelector(
      '[data-tid="verify-email-input-0"]',
    );

    if (inputElement) {
      (inputElement as HTMLInputElement).focus();
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    index: number,
  ) => {
    const { value } = e.target;

    const newCode = code.split("");
    newCode[index] = value.replace(/\D/g, "");
    setCode(newCode.join("").slice(0, length));

    if (value.length === 1 && index < length - 1) {
      const nextInputElement = document.querySelector(
        `[data-tid="verify-email-input-${index + 1}"]`,
      );

      if (nextInputElement) {
        (nextInputElement as HTMLInputElement).focus();
        (nextInputElement as HTMLInputElement).select();
      }
    } else {
      (e.target as HTMLInputElement).select();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newCode = code.split("");
      newCode[index] = "";
      setCode(newCode.join(""));

      if (index > 0) {
        const prevInputElement = document.querySelector(
          `[data-tid="verify-email-input-${index - 1}"]`,
        );
        if (prevInputElement) {
          (prevInputElement as HTMLInputElement).focus();
          (prevInputElement as HTMLInputElement).select();
        }
      }
    }

    let nextInputElement: HTMLInputElement | null = null;

    if (e.key === "ArrowLeft") {
      e.preventDefault();
      nextInputElement = document.querySelector(
        `[data-tid="verify-email-input-${index - 1}"]`,
      );
    }

    if (e.key === "ArrowRight") {
      e.preventDefault();
      nextInputElement = document.querySelector(
        `[data-tid="verify-email-input-${index + 1}"]`,
      );
    }

    if (nextInputElement) {
      (nextInputElement as HTMLInputElement).focus();
      (nextInputElement as HTMLInputElement).select();
    }
  };

  const handlePaste = (
    e: React.ClipboardEvent<HTMLInputElement>,
    index: number,
  ) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData("text/plain").replace(/\D/g, "");
    const newCode = code.split("");
    const pasteDataArray = pasteData.split("");
    const nextIndex = index + pasteDataArray.length - 1;

    for (let i = 0; i < pasteDataArray.length; i++) {
      newCode[index + i] = pasteDataArray[i];
    }

    setCode(newCode.join("").slice(0, length));

    if (index < length - 1) {
      const nextInputElement = document.querySelector(
        `[data-tid="verify-email-input-${nextIndex}"]`,
      );

      if (nextInputElement) {
        (nextInputElement as HTMLInputElement).focus();
        (nextInputElement as HTMLInputElement).select();
      }
    }
  };

  return (
    <div className="mb-2 mt-2">
      <div className="flex justify-center gap-2">
        {Array.from({ length }).map((_, index) => (
          <Input
            value={code[index] || ""}
            key={index}
            data-tid={`verify-email-input-${index}`}
            onChange={(e) => handleInputChange(e, index)}
            onKeyDown={(e) => handleKeyDown(e, index)}
            onPaste={(e) => handlePaste(e, index)}
            onClick={(e) => (e.target as HTMLInputElement).select()}
            onFocus={(e) => (e.target as HTMLInputElement).select()}
            className="h-12 w-12 rounded-lg border border-gray-300 text-center text-xl font-medium focus:border-blue-500 focus:ring-blue-500"
          />
        ))}
      </div>
      {errorMessage && (
        <p className="mt-1 text-sm text-red-500">{errorMessage}</p>
      )}
    </div>
  );
};
